{
	"about": {
		"title": "About",
		"version": "Version",
		"build-number": "Build number",
		"new-version": "New version"
	},
	"legal": {
		"privacy-policy": "Privacy Policy",
		"terms-of-use": "Terms of Use"
	}
}
